import React from "react";

import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";

const Content = (props) => {
  const { titulo, contenido, imagen } = props;
  return (
    <React.Fragment>
      <Container
        style={{ paddingTop: "4em", color: "white", paddingBottom: "1em" }}
      >
        <Row className="centrado">
          <h1 className="encabezado">{titulo}</h1>
        </Row>
        <Row>
          <Col sm="12" md="6" lg="6">
            <p style={{ fontSize: "20px", textAlign: "justify" }}>
              {contenido}
            </p>
          </Col>
          <Col sm="12" md="6" lg="6">
            <Image
              src={imagen}
              width="600px"
              height="450px"
              fluid
              alt="content_image"
            />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Content;
